import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-Up</Title>

                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial P.M.;</li>
                            <li>Axial P.M. L1-L2;</li>
                            <li>Axial P.M. L2-L3;</li>
                            <li>Axial P.M. L3-L4;</li>
                            <li>Axial P.M. L4-L5;</li>
                            <li>Axial P.M. L5-S1;</li>
                            <li>Axial Osso;</li>
                            <li>Axial Osso L1-L2;</li>
                            <li>Axial Osso L2-L3;</li>
                            <li>Axial Osso L3-L4;</li>
                            <li>Axial Osso L4-L5;</li>
                            <li>Axial Osso L5-S1;</li>
                            <li>Sagital P.M.;</li>
                            <li>Sagital Osso</li>
                            <li>Coronal P.M.;</li>
                            <li>Coronal Osso;</li>
                            <li>3D VR Coluna Lombar Dir. / Esq.</li>
                            <li>3D VR Coluna Lombar Sup. / Inf.</li>
                            <li>Relatório de dose;</li>
                        </ul>
                    </section>
                </div>
            </div>
        </Container>
    )
}